import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import EmbeddedRegistrationForm from '../../components/embedded/EmbeddedRegistrationForm';

const EmbedPage = () => {
    const { tiendaId } = useParams();
    const [searchParams] = useSearchParams();
    const [embedConfig, setEmbedConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    // Obtener configuración desde URL params
    const theme = searchParams.get('theme') || 'default';
    const customStyles = {
        primaryColor: searchParams.get('primaryColor') || null,
        backgroundColor: searchParams.get('backgroundColor') || null,
        textColor: searchParams.get('textColor') || null,
        borderRadius: searchParams.get('borderRadius') || null,
        fontFamily: searchParams.get('fontFamily') || null
    };

    // Limpiar valores null
    Object.keys(customStyles).forEach(key => {
        if (customStyles[key] === null) {
            delete customStyles[key];
        }
    });

    useEffect(() => {
        // Aquí podrías cargar configuración adicional desde el backend
        // Por ahora usamos los parámetros de la URL
        setLoading(false);
    }, [tiendaId]);

    const handleSuccess = (data) => {
        // Enviar mensaje al parent window si está en iframe
        if (window.parent !== window) {
            window.parent.postMessage({
                type: 'PETITSHOP_EMBED_SUCCESS',
                data: data
            }, '*');
        }

        // Mostrar mensaje de éxito
        alert('¡Registro exitoso! Te has unido al club de clientes.');
    };

    const handleError = (error) => {
        // Enviar mensaje al parent window si está en iframe
        if (window.parent !== window) {
            window.parent.postMessage({
                type: 'PETITSHOP_EMBED_ERROR',
                error: error.message
            }, '*');
        }

        // Mostrar mensaje de error
        alert(`Error: ${error.message}`);
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '400px',
                fontFamily: 'system-ui, sans-serif'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #3B82F6',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 1rem'
                    }}></div>
                    <p>Cargando formulario...</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#ffffff',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            lineHeight: '1.6'
        }}>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                /* Reset básico para evitar conflictos con CSS del sitio host */
                * {
                    box-sizing: border-box;
                }
                
                body {
                    margin: 0;
                    padding: 0;
                }
                
                /* Asegurar que el formulario sea responsive */
                .embedded-registration-form {
                    max-width: 100%;
                    overflow-x: hidden;
                }
                
                /* Estilos para inputs en diferentes navegadores */
                input, select, textarea {
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                }
                
                /* Mejorar accesibilidad */
                input:focus, select:focus, textarea:focus {
                    outline: 2px solid #3B82F6;
                    outline-offset: 2px;
                }
            `}</style>

            <EmbeddedRegistrationForm
                embedCode={tiendaId}
                customStyles={customStyles}
                theme={theme}
                onSuccess={handleSuccess}
                onError={handleError}
                showHeader={true}
                showBenefits={true}
                className="embed-page-form"
            />
        </div>
    );
};

export default EmbedPage;
